import React from 'react';
import { productColors } from '../config/colors';

const OrderItems = ({ currentItem, setCurrentItem }) => {
  const productTypes = ['T-Shirts', 'Hoodies', 'Hats'];
  const sizes = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];

  const handleItemChange = (e) => {
    const { name, value } = e.target;
    setCurrentItem(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleColorSelect = (colorValue) => {
    setCurrentItem(prev => ({
      ...prev,
      color: colorValue
    }));
  };

  return (
    <div className="border-t border-gray-700 pt-8">
      <h3 className="text-lg font-medium text-magenta-500 mb-4">Order Items</h3>
      
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <div className="bg-gray-800 p-4 rounded-lg">
          <label htmlFor="type" className="block text-sm font-medium text-gray-300">
            Product Type
          </label>
          <select
            name="type"
            value={currentItem.type}
            onChange={handleItemChange}
            className="mt-2 block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-cyan-500 focus:ring-cyan-500 px-3 py-2"
          >
            {productTypes.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>

        <div className="bg-gray-800 p-4 rounded-lg">
          <label htmlFor="quantity" className="block text-sm font-medium text-gray-300">
            Quantity
          </label>
          <input
            type="number"
            name="quantity"
            min="1"
            value={currentItem.quantity}
            onChange={handleItemChange}
            className="mt-2 block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-cyan-500 focus:ring-cyan-500 px-3 py-2"
          />
        </div>

        <div className="bg-gray-800 p-4 rounded-lg">
          <label htmlFor="size" className="block text-sm font-medium text-gray-300">
            Size
          </label>
          <select
            name="size"
            value={currentItem.size}
            onChange={handleItemChange}
            className="mt-2 block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-cyan-500 focus:ring-cyan-500 px-3 py-2"
          >
            {sizes.map(size => (
              <option key={size} value={size}>{size}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="mt-4 bg-gray-800 p-4 rounded-lg">
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Color
        </label>
        <div className="grid grid-cols-5 gap-3">
          {productColors.map(color => (
            <button
              key={color.value}
              type="button"
              onClick={() => handleColorSelect(color.value)}
              className={`w-full h-8 rounded-md border-2 ${
                currentItem.color === color.value 
                  ? 'border-cyan-500' 
                  : 'border-transparent'
              }`}
              style={{ backgroundColor: color.value }}
              title={color.name}
            />
          ))}
        </div>
        <span className="mt-2 block text-sm text-gray-400">
          {productColors.find(c => c.value === currentItem.color)?.name || 'Select a color'}
        </span>
      </div>
    </div>
  );
};

export default OrderItems;